// Copyright 2019 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { Repository } from "repositories/Repository";
import { RepresentativeDTO } from "./../datatypes/SoramaWebApi";

@autoinject
export class RepresentativeRepository extends Repository {
    private webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler) {
        super();
        this.webRequestHandler = webRequestHandler;
    }

    //#region GetRequests
    public getRepresentative(id: string): Promise<RepresentativeDTO> {
        return this.webRequestHandler
            .createGetRequest<RepresentativeDTO>(Api.representatives + "/" + id)
            .send()
            .then((x) => x.content);
    }

    //#endregion

    //#region PostRequests

    //#endregion

    //#region Put Collections Requests

    public putEmailAddress(repId: string, newEmail: string): Promise<void> {
        if (this.validateEmail(newEmail)) return Promise.reject("Invalid email address.");

        return this.webRequestHandler
            .createPutRequest(Api.representatives + "/" + repId + "?Email=" + newEmail)
            .send()
            .then(() => {});
    }

    //#endregion

    //#region Delete Requests

    //#endregion

    public validateEmail(email: string): boolean {
        const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}
